/**
 * A single edit-diff entry in an order/detail draft. `data` is intentionally
 * `unknown` — delete-type diffs carry no `data`, set-type diffs carry an object,
 * and consumers cast at the point of use.
 */
export interface Diff {
  event?: string;
  scope: string;
  data?: unknown;
  [key: string]: unknown;
}

/**
 * Returns a new diffs array with the add-diff for a specific draft item removed.
 *
 * Safe when delete-type diffs (which have no `data` property) coexist in the
 * same scope — uses optional chaining to avoid crashes.
 *
 * @param diffs   - current diffs state array
 * @param scope   - scope name (e.g. 'additionalCharges', 'packages')
 * @param draftId - _id of the draft item to remove
 */
export function removeDraftDiff(diffs: Diff[], scope: string, draftId: string | number): Diff[] {
  return diffs.filter(
    (d) => !(d.scope === scope && (d.data as { _id?: string | number } | undefined)?._id === draftId),
  );
}
